import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const CTASection = () => {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-b from-bg-main to-brand-sage/20" data-testid="cta-section">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="font-manrope text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary tracking-tight mb-10">
            Empieza con una valoración clara y un plan a medida
          </h2>

          <div className="flex justify-center">
            <Link
              to="/como-funciona"
              className="btn-primary inline-flex items-center justify-center gap-2 group"
              data-testid="cta-primary"
            >
              Reservar consulta
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
